import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='foot-big'>
        <p className='foot'>Developed with ❤️ by <a className="identity" target="_blank" href="https://www.linkedin.com/in/abhishek-dhanke-226354216/">Abhishek</a></p>
    </div>
  )
}

export default Footer